export default "__VITE_ASSET__H8N94JPG__"